export default __webpack_public_path__ + "static/media/delivery-man-dark.5f53ea97.png";